import { Stack } from '@mui/material';
import { ResourcesRequestForm } from '@NewRequest/organisms/ResourcesRequestForm';

export default function ResourcesRequestPage() {
  return (
    <Stack spacing={2} maxWidth="50rem">
      <ResourcesRequestForm />
    </Stack>
  );
}
